module.exports = __webpack_public_path__ + "images/data-camp-img1-fa.jpg";